export function formatEventDate(iso?: string | null): string | null {
  if (!iso) return null;
  const [y, m, d] = iso.split('-');
  if (!y || !m || !d) return iso;
  return `${d}.${m}.${y}`;
}

export function todayIsoDate(): string {
  return new Date().toISOString().slice(0, 10);
}
